import Auth, { FetchAPI } from './auth-service';

const MC2CHECK = (process.env.BRICATA_APPLIANCE_TYPE === 'mc2');

class ZeekDataService {
    constructor () {
        if (!ZeekDataService.instance) {
            ZeekDataService.instance = this;
        }
        this.searchPlaceholder = 'Search Zeek scripts';

        this.clearImportsDirectory = () => {
            return FetchAPI({
                url: 'rules/file/bro/imports/',
                method: 'DELETE',
            });
        };

        this.getScriptsURL = () => {
            return FetchAPI({
                url: 'rules/file/bro/url-conf/',
                method: 'GET',
            });
        };

        this.updateScriptsURL = (data) => {
            return FetchAPI({
                url: 'rules/file/bro/url-conf/',
                method: 'POST',
                body: data,
            });
        };

        this.getPolicyConfiguration = (group, type) => {
            return FetchAPI({
                url: `rules/policy/bro/conf/${group}/${type}`,
                method: 'GET',
            });
        };

        this.updatePolicyConfiguration = (group, type, data) => {
            return FetchAPI({
                url: `${MC2CHECK ? 'mc2/' : ''}rules/policy/bro/conf/${group}/${type}`,
                method: 'PUT',
                body: data,
            });
        };

        this.downloadBroScriptsLibrary = (name, type) => {
            const a = Auth.getAuth();

            return fetch(`/api/rules/policy/bro/lib/${name}/${type}`, {
                method: 'GET',
                body: undefined,
                cache: 'default',
                headers: {
                    Authorization: `Bearer ${a.token}`,
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).then((res) => {
                return res.arrayBuffer().then((buffer) => {
                    return buffer;
                });
            }).catch(response => {
                if ([401, 403].indexOf(response.status) !== -1) {
                    return Auth.boot();
                }
            });
        };

        this.getScriptsList = (group, type, search) => {
            return FetchAPI({
                url: `rules/policy/bro/list/${group}/${type}`,
                method: 'GET',
            }).then((res) => {
                if (search) {
                    return res.filter((v) => Object.keys(v).reduce((a, c) => {
                        if (a) {
                            return a;
                        }
                        return v[c].toString().toLowerCase().includes(search.toLowerCase());
                    }, false));
                }
                return res;
            });
        };

        this.updateScriptsList = (group, type, data) => {
            return FetchAPI({
                url: `${MC2CHECK ? 'mc2/' : ''}rules/policy/bro/list/${group}/${type}`,
                method: 'PUT',
                body: data,
            });
        };

        this.getScript = (type, folder, name) => {
            return FetchAPI({
                url: `rules/policy/bro/script/${type}/${folder}/${name}`,
                method: 'GET',
            });
        };

        this.updateScript = (type, folder, name, details) => {
            return FetchAPI({
                url: `rules/policy/bro/script/${type}/${folder}/${name}`,
                method: 'PUT',
                body: {
                    name: details.name,
                    content: details.content,
                }
            });
        };

        this.deleteScript = (type, folder, name) => {
            return FetchAPI({
                url: `rules/policy/bro/script/${type}/${folder}/${name}`,
                method: 'DELETE',
            });
        };

        this.createScript = (type, name, content) => {
            return FetchAPI({
                url: `rules/policy/bro/script/${type}/${name}`,
                method: 'POST',
                body: {
                    content: content,
                }
            });
        };

        this.uploadBroScriptsFile = (type, content) => {
            const a = Auth.getAuth();
            const form = new FormData();
            form.append('uploadfile', content);

            return fetch(`/api/rules/policy/bro/upload/${type}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${a.token}`,
                },
                body: form,
            }).then((res) => {
                return res.text().then(text => {
                    let data = text;
                    try {
                        data = text && JSON.parse(text);
                    } catch (err) {
                        if ((text || '').trim() !== 'null') {
                            data = text;
                        }
                    }

                    if (!res.ok) {
                        return Promise.reject(data);
                    }

                    return data;
                });
            }).catch(error => {
                if ([401, 403].indexOf(error.status) !== -1) {
                    return Auth.boot();
                }

                return Promise.reject(error);
            });
        };

        this.manuallyKickBroScriptsImport = () => {
            return FetchAPI({
                url: 'rules/file/bro/kick/',
                method: 'PUT',
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_zeek') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_zeek', JSON.stringify(searches));
        };

        return ZeekDataService.instance;
    }
}

const ZeekService = new ZeekDataService();

export {
    ZeekService as default,
};
